import { createStore, applyMiddleware, compose } from "redux";
import thunkMiddleware from "redux-thunk";
import logger from "redux-logger";
import rootReducer from "../reducers/index";
import { env } from "../../env";

let composeEnhancers = compose;
if (
  env.NODE_ENV !== "production" &&
  window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
) {
  composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;
}

export default function configureStore(preloadedState) {
  const store = createStore(
    rootReducer, // root reducer with router state
    preloadedState,
    composeEnhancers(applyMiddleware(thunkMiddleware), applyMiddleware(logger)),
  );
  return store;
}
